import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import {
  useAddDeviceMutation,
  useCompanyDeviceEditMutation,
  useCompanyDeviceListMutation,
  useDeviceListMutation,
  useLazyCompanyDeviceStatusQuery,
  useLazyCompanyDevicesViewQuery,
  useLazyCompanyLocationListQuery,
  useLazyDeviceStatusQuery,
  useLazyManualTriggerQuery,
  useLazyViewDeviceQuery,
  useUpdateDeviceMutation,
} from "../../redux/api/api";
import apiRequest from "../../redux/api/apiRequest";
import {
  edit_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import CustomSearchSelect from "../../../components/Searchbox/CustomSearch";
import DownloadingIcon from "@mui/icons-material/Downloading";

const DeviceCompanyList = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [list, setList] = useState([]);
  const [pagination, setPagination] = useState("");
  const [loader, setLoader] = useState(false);
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const logindata = JSON.parse(localStorage.getItem("loginData"));
  const [deviceId, setDeviceId] = useState("");
  const [deviceLat, setDeviceLat] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [deviceLocation, setDeviceLocation] = useState("");
  const [deviceLng, setDeviceLng] = useState("");
  const [lightDistance, setLightDistance] = useState("");
  const [bufferTime, setBufferTime] = useState("");
  const [assigned, setAssigned] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState();
  const [assignedList, setAssignedList] = useState([]);
  const [search, setSearch] = useState("");
  const [locList, setLoclist] = useState([]);
  const [Ids, setIds] = useState("");
  const [count, setCount] = useState("");
  const [error, setError] = useState(false);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [userData, setUserData] = useState(null);
  const [change, setChange] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [DeviceStatus] = useLazyCompanyDeviceStatusQuery();
  const [companyDeviceList] = useCompanyDeviceListMutation();
  const [addDevice] = useAddDeviceMutation();
  const [updateDevice] = useCompanyDeviceEditMutation();
  const [viewDevice] = useLazyCompanyDevicesViewQuery();
  const [companyLocationList] = useLazyCompanyLocationListQuery();
  const [manualTriggerApi] = useLazyManualTriggerQuery();

  const [type, setType] = useState("");

  // const company = localStorage.getItem("company");
  const company = JSON.parse(localStorage.getItem("company"));
  const companyName = company?.name;

  const handleStatus = async (id) => {
    const res = await apiRequest(DeviceStatus, id);
    if (res?.status == "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const filterList = (list, val) => {
    let uppercaseval = val?.toLocaleUpperCase();
    let data = list?.filter((data) => {
      if (
        data?.name?.toLocaleUpperCase()?.indexOf(uppercaseval) >= 0 ||
        data?.email?.toLocaleUpperCase()?.indexOf(uppercaseval) >= 0
      ) {
        return true;
      }
    });
    return data;
  };

  const getList = async (search) => {
    const formdata = new FormData();
    formdata.append("rows", 10);
    formdata.append("page", page);
    formdata.append("search", search ? search : "");
    formdata.append("order", "asc");

    const res = await apiRequest(companyDeviceList, formdata);
    if (res?.status == "success") {
      setList(res?.lists);
      setCount(res?.pagination_meta);
      setPagination(res?.pagination_meta);
    }
  };

  const getLocationList = async () => {
    const res = await apiRequest(companyLocationList);
    if (res?.status == "success") {
      setLoclist(res?.data);
    }
  };

  useEffect(() => {
    if (givenpermissions?.includes("COMPANY-CAN-List-COMPANY_DEVICES")) {
      getList();
    }
    getLocationList();
  }, [page]);

  console.log("testing log", !lightDistance, !bufferTime);
  const Add = async () => {
    if (
      !deviceName ||
      !deviceId ||
      !deviceLocation ||
      !deviceLat ||
      !deviceLng ||
      !lightDistance ||
      !bufferTime ||
      lightDistance == "null" ||
      bufferTime == "null" ||
      !assigned
    ) {
      setError(true);
      return;
    }
    setError(false);
    const formdata = new FormData();
    formdata.append("device_name", deviceName);
    formdata.append("device_code", deviceId);
    let assign = [];
    assign.push(assigned);
    console.log("assigned", assign);
    if (type == "edit") {
      formdata.append("latitude", deviceLat);
      formdata.append("longitude", deviceLng);
      formdata.append("lighting_distance", lightDistance);
      formdata.append("lighting_buffer_time", bufferTime);
      // formdata.append("device_id", Ids);
      formdata.append("location", deviceLocation);
      assign?.map((item, ind) => {
        formdata.append(`assigned_to[${ind}]`, item);
      });
    }
    setLoader(true);
    const res = await apiRequest(updateDevice, formdata, Ids);
    setLoader(false);
    if (res?.status == "success") {
      toast.success(res?.message);
      setPopup(false);
      setType("");
    } else {
      toast.error("Error");
    }
    getList();
  };

  const View = async (id, type) => {
    setType(type);
    setDeviceId("");
    setDeviceName("");
    setAssigned("");
    setIds(id);
    const res = await apiRequest(viewDevice, id);
    if (res?.status == "success") {
      let data = res?.data;
      setDeviceName(data?.device_name);
      setDeviceId(data?.device_code);
      setDeviceLat(data?.latitude);
      setDeviceLocation(data?.location?.id);
      setDeviceLng(data?.longitude);
      setLightDistance(data?.lighting_distance);
      setBufferTime(data?.lighting_buffer_time);
      setAssigned(data?.assigned_ids?.[0]);
      setAssignedList(data?.assigned_to);
      setSearch(data?.assigned?.name);
      setUsers(res?.primary_users);
      setPopup(true);
    }
  };

  const manualTrigger = (id) => {
    setLoading(true);
    manualTriggerApi(id)
      .unwrap()
      .then((res) => {
        setLoading(false);
        if (res?.status == "success") {
          toast.success(res?.message);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
  };

  const handleDownload = (date) => {
    try {
      const a = document.createElement("a");
      let params = `?date=${date}&download=true`;
      // a.href = `${BASE_URL + URL.LOG_FILE + params}`
      a.setAttribute("target", "_blank");
      a.download = `${date}.log`;
      a.click();
    } catch (error) {
      console.log("error", error);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      // {
      //   Header: "Manual Trigger",
      //   accessor: "device_name_",
      //   Cell: ({ value, row }) => {
      //     return (
      //       <div>
      //         <button
      //           onClick={() => {
      //             if (givenpermissions?.includes("CAN-Status-DEVICES")) {
      //               manualTrigger(row.original.device_code);
      //             }
      //           }}
      //           className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
      //           style={{ backgroundColor: "#ffc701" }}
      //         >
      //           Trigger
      //         </button>
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Device Name",
        accessor: "device_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Device ID",
        accessor: "device_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Device Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <p
              onClick={() => {
                setUserData(row.original.assigned);
              }}
              className="pointerView assigned text-decoration-underline"
            >
              {value ? value : "--"}
            </p>
          );
        },
      },
      {
        Header: "Location",
        accessor: "device_location",
        Cell: ({ value, row }) => {
          return <p>{value ? value : "--"}</p>;
        },
      },
      {
        Header: "View Members",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  navigate(`/${companyName}/members-list`, {
                    state: { data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Device Report",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  navigate(`/${companyName}/report-list`, {
                    state: { data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Notification Report",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  navigate(`/${companyName}/notification-report-list`, {
                    state: { data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Device Status",
        accessor: "device_status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button className={`border-0 toggle-btn cust-btn `}>
                {value == 1 ? (
                  <div>
                    <FavoriteIcon className="green" />
                  </div>
                ) : (
                  <div>
                    <FavoriteIcon className="red" />
                  </div>
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Download",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                <button
                  onClick={() => handleDownload(row.original.date)}
                  className="cust-btn"
                >
                  <DownloadingIcon className="text-danger" />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
      {
        Header: " Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (
                    givenpermissions?.includes(
                      "COMPANY-CAN-Status-COMPANY_DEVICES"
                    )
                  ) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`border-0 ms-2 cust-btn ${
                  givenpermissions?.includes(
                    "COMPANY-CAN-Status-COMPANY_DEVICES"
                  )
                    ? ""
                    : "opacity-50"
                }`}
              >
                {value == 1 ? (
                  <img className="toggle-btn" src={toggle_on} />
                ) : (
                  <img className="toggle-btn" src={toggle_off} />
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {givenpermissions?.includes(
                  "COMPANY-CAN-View-COMPANY_DEVICES"
                ) && (
                  <button
                    onClick={() => {
                      View(row.original.id, "view");
                      setPopup(true);
                      setType("view");
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {givenpermissions?.includes(
                  "COMPANY-CAN-Edit-COMPANY_DEVICES"
                ) && (
                  <button
                    type="edit"
                    onClick={() => {
                      View(row.original.id, "edit");
                      setIds(row.original.id);
                      setPopup(true);
                      setType("edit");
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div className="dashRightView home_section">
      {loading && (
        <div
          style={{ zIndex: 1500, position: "fixed", top: "45%", left: "49%" }}
        >
          <Spinner animation="border" className="primary" />
        </div>
      )}
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
          Device List
        </h2>
        {/* <div className="input-pop ps-2">
                    <CustomSearchSelect
                        options={list}
                        value={selectedCityId}
                        // locationLoader={locationLoader}
                        onChange={(value) => {
                            setSelectedCityId(value);
                            getList(1,  search);
                        }}
                        placeholder="Select Company"
                        width="200px"

                    />
                </div> */}
      </div>
      <div className="d-flex ac-js mt-2 ">
        <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  mb-0 ">
          Total Count :
        </h4>
        <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
          {count?.total}
        </h4>
        <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 mb-0 ms-3">
          Search
        </h4>
        <input
          type="text"
          className="input-pop ps-2"
          placeholder=" Search"
          onChange={(e) => {
            getList(e.target.value);
          }}
        />
      </div>
      {popup && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                {type == "edit"
                  ? "Edit Device"
                  : type == "view"
                  ? "View Device"
                  : "Add Device"}
              </h2>
              <button
                onClick={() => {
                  setPopup(false);
                  setType("");
                  setDeviceName("");
                  setDeviceId("");
                  setDeviceLat("");
                  setDeviceLng("");
                  setDeviceLocation("");
                  setLightDistance("");
                  setBufferTime("");
                  setAssigned("");
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Device Name
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder=" Name"
              onChange={(e) => {
                setDeviceName(e.target.value);
              }}
              value={deviceName}
              disabled={type == "view" ? true : false}
            />
            {error && !deviceName && <p className="err">Enter Device Name</p>}

            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Device ID
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Device ID"
              onChange={(e) => {
                setDeviceId(e.target.value);
              }}
              value={deviceId}
              disabled={type == "view" ? true : false}
            />
            {error && !deviceId && <p className="err">Enter Device ID</p>}
            {/* {type == "edit" && ( */}
            <div>
              <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                Device Location
              </h4>
              <select
                className="input-pop ps-2 w-100"
                onChange={(e) => {
                  setDeviceLocation(e.target.value);
                }}
                value={deviceLocation}
                disabled={type == "view" ? true : false}
              >
                <option>Select Location</option>
                {locList.map((item) => {
                  return <option value={item?.id}>{item?.name}</option>;
                })}
              </select>
              {error && !deviceId && (
                <p className="err">Enter Company Name and Location</p>
              )}
              {/* {(type == "edit" || type == "view") && ( */}
              <>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Device Latitude
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Device Latitude"
                  onChange={(e) => {
                    setDeviceLat(e.target.value);
                  }}
                  value={deviceLat}
                  disabled={type == "view" ? true : false}
                />
                {error && !deviceLat && (
                  <p className="err">Enter Device Latitude</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Device Longitude
                </h4>
                <input
                  type="text"
                  className="input-pop ps-2 w-100"
                  placeholder="Device Longitude"
                  onChange={(e) => {
                    setDeviceLng(e.target.value);
                  }}
                  value={deviceLng}
                  disabled={type == "view" ? true : false}
                />
                {error && !deviceLng && (
                  <p className="err">Enter Device Longitude</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Lightening Distance(km)
                </h4>
                <input
                  type="number"
                  className="input-pop ps-2 w-100"
                  placeholder="Lightening Distance"
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 2))}
                  onChange={(e) => {
                    setLightDistance(e.target.value);
                  }}
                  value={lightDistance}
                  disabled={type == "view" ? true : false}
                />
                {error && (!lightDistance || lightDistance == "null") && (
                  <p className="err">Enter Lightening Distance</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Buffer Time(mins)
                </h4>
                <input
                  type="number"
                  className="input-pop ps-2 w-100"
                  placeholder="Buffer Time"
                  onChange={(e) => {
                    setBufferTime(e.target.value);
                  }}
                  value={bufferTime}
                  disabled={type == "view" ? true : false}
                />
                {error && (!bufferTime || bufferTime == "null") && (
                  <p className="err">Enter Buffer Time</p>
                )}
                <div className="position-relative">
                  <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                    Assigned To
                  </h4>
                  <select
                    disabled={type == "view" ? true : false}
                    className="input-pop ps-2 w-100"
                    name="city"
                    onChange={(e) => {
                      setAssigned(e.target.value);
                    }}
                    value={assigned}
                  >
                    <option className=""> -- Select -- </option>
                    {assignedList.map((item) => {
                      return (
                        <option value={item?.id} className="">
                          {" "}
                          {item?.name} - {item?.email}{" "}
                        </option>
                      );
                    })}
                  </select>
                  {error && !assigned && <p className="err">Assign The User</p>}
                </div>
              </>
            </div>
            {/* )} */}
            {/* )} */}
            {type != "view" && (
              <div className="d-flex ac-jc mt-3">
                <button
                  onClick={() => {
                    Add(popup);
                  }}
                  className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                >
                  {loader && (
                    <div
                      class="spinner-border spinner-border-sm "
                      role="status"
                      style={{ marginRight: "5px" }}
                    ></div>
                  )}
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {userData && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                view User
              </h2>
              <button
                onClick={() => {
                  setUserData(null);
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Email
            </h4>
            <input
              type="email"
              className="input-pop ps-2 w-100"
              placeholder=" Email Address"
              name="email"
              value={userData?.email}
              disabled={true}
            />
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Name
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder=" Name"
              name="name"
              value={userData?.name}
              disabled={true}
            />
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Phone Number (Singapore)
            </h4>
            <input
              type="number"
              className="input-pop ps-2 w-100"
              placeholder="Phone Number (Singapore)"
              name="phone"
              value={userData?.phone}
              disabled={true}
            />
          </div>
        </div>
      )}
      <Table
        columns={columns}
        data={list}
        show={true}
        pagecount={pagination}
        setPageno={setPage}
      />
      {change && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, you want to reallocate this device?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  setChange(false);
                }}
                className="no-btn"
              >
                No
              </button>
              <button
                onClick={() => {
                  setAssigned(change == 0 ? "" : change?.id);
                  setSearch(change == 0 ? "" : change?.name);
                  setChange(false);
                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceCompanyList;
